/* Photographs on the enquiry forms (snippets/photo-upload-field.liquid; A38, Eli 2026-10-14).
   Contract with the upload functions: output/photo-upload-build-2026-10-14/CONTRACT.md.

   Each chosen photograph is shrunk in the browser to 2048px on its long edge, JPEG quality 0.8
   (the staff app's setting), then sent straight to the store's private storage: one ticket request
   per batch of choices, then one PUT per photograph, one retry each, abandoned after 60 seconds
   without progress. A photograph the browser cannot decode (HEIC on desktop Chrome) goes as it is
   when its type is allowed and it is 10 MB or less.

   Just before the form posts, write() fills the one `contact[Photos]` line the store's email shows
   (CONTRACT section 4). contact-form-state.js holds Send while anything is still on its way, reading
   form.fjbcPhotos. The file input has no name and nothing here enters the session draft.

   Round 2 (CONTRACT section 6, Eli 2026-10-15): the store's email joins every line into one block,
   so once at least one photograph is sent, the first submit asks for one gallery link covering them
   all (10 seconds at most) and the line carries that link; if the call fails, numbered links follow
   on the same line. Send stays held while the gallery call runs. */
(function () {
  if (window.FJBCPhotoUpload) return;
  window.FJBCPhotoUpload = true;

  var MAX_FILES = 5;
  var MAX_BYTES = 10485760;
  var MAX_TOTAL = 26214400;
  var LONG_EDGE = 2048;
  var QUALITY = 0.8;
  var STALL_MS = 60000;
  var TICKET_TIMEOUT_MS = 30000;
  var GALLERY_TIMEOUT_MS = 10000;
  var PREPARE_MS = 20000;
  var THUMB_PX = 192;
  var EMAIL = 'info@finejewellerybycolette.com';
  var ALLOWED = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];
  var EXTENSIONS = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', heic: 'image/heic', heif: 'image/heif' };
  var NUMBERS = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];

  function photographs(n) {
    return n === 1 ? 'photograph' : 'photographs';
  }

  function spelled(n) {
    return NUMBERS[n] || String(n);
  }

  /* Windows and some Android pickers report an empty type for HEIC; the extension decides. */
  function fileType(file) {
    var type = (file.type || '').toLowerCase();
    if (type === 'image/jpg') type = 'image/jpeg';
    if (type) return type;
    var match = /\.([a-z0-9]+)$/i.exec(file.name || '');
    return match ? EXTENSIONS[match[1].toLowerCase()] || '' : '';
  }

  function decode(file) {
    if (typeof window.createImageBitmap !== 'function') return Promise.reject(new Error('no decoder'));
    return window.createImageBitmap(file, { imageOrientation: 'from-image' }).catch(function () {
      return window.createImageBitmap(file);
    });
  }

  /* Resolves { blob, type, thumb } or rejects with a message for the row. Once guard.expired is
     set (prepareWithin gave up), a late bitmap is closed and a late result is dropped. */
  function prepare(file, guard) {
    var type = fileType(file);
    if (type.indexOf('image/') !== 0) {
      return Promise.reject(new Error('This file is not a photograph. Please choose a JPEG, PNG or HEIC photograph.'));
    }
    return decode(file).then(function (bitmap) {
      if (guard.expired) {
        if (bitmap.close) bitmap.close();
        throw new Error('expired');
      }
      var scale = Math.min(1, LONG_EDGE / Math.max(bitmap.width, bitmap.height));
      var width = Math.max(1, Math.round(bitmap.width * scale));
      var height = Math.max(1, Math.round(bitmap.height * scale));
      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var context = canvas.getContext('2d');
      /* A transparent PNG would turn black as a JPEG. */
      context.fillStyle = '#FFFFFF';
      context.fillRect(0, 0, width, height);
      context.imageSmoothingQuality = 'high';
      context.drawImage(bitmap, 0, 0, width, height);
      if (bitmap.close) bitmap.close();
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          canvas.width = 0;
          canvas.height = 0;
          if (guard.expired) reject(new Error('expired'));
          else if (blob && blob.size > 0 && blob.size <= MAX_BYTES) resolve({ blob: blob, type: 'image/jpeg', thumb: true });
          else reject(new Error('encode'));
        }, 'image/jpeg', QUALITY);
      });
    }).catch(function (error) {
      if (guard.expired) throw error;
      /* Could not be decoded or re-encoded here: send the original if the bucket accepts it. */
      if (ALLOWED.indexOf(type) >= 0 && file.size > 0 && file.size <= MAX_BYTES) {
        return { blob: file, type: type, thumb: type !== 'image/heic' && type !== 'image/heif' };
      }
      if (file.size > MAX_BYTES) throw new Error('This photograph is larger than 10 MB and could not be prepared. Please email it to us.');
      throw new Error('This file could not be read. Please choose a JPEG, PNG or HEIC photograph.');
    });
  }

  /* A decoder that never answers (a damaged or very large phone photograph) must not hold Send:
     after PREPARE_MS the photograph fails, and whatever the browser finishes later is discarded. */
  function prepareWithin(file) {
    var guard = { expired: false };
    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(function () {
        guard.expired = true;
        reject(new Error('This photograph could not be prepared. Please email it to us.'));
      }, PREPARE_MS);
      prepare(file, guard).then(function (result) {
        window.clearTimeout(timer);
        resolve(result);
      }, function (error) {
        window.clearTimeout(timer);
        reject(error);
      });
    });
  }

  function requestTickets(base, kind, items, attempt) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, TICKET_TIMEOUT_MS) : null;
    return fetch(base + '/website-photo-upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      signal: controller ? controller.signal : undefined,
      body: JSON.stringify({
        form: kind,
        files: items.map(function (item) { return { type: item.type, size: item.blob.size }; })
      })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (timer) window.clearTimeout(timer);
        if (response.ok && data && Array.isArray(data.uploads)) return data;
        var error = new Error('ticket');
        error.status = response.status;
        error.code = data && data.error;
        throw error;
      });
    }, function (networkError) {
      if (timer) window.clearTimeout(timer);
      var error = new Error('network');
      error.status = 0;
      throw error;
    }).catch(function (error) {
      /* One retry for a network fault or a server error; never for a refusal, the rate limit or
         the capacity budget (503 capacity: a second request in the same moment cannot pass). */
      if ((attempt || 0) < 1 && (error.status === 0 || error.status >= 500) && error.code !== 'capacity') {
        return requestTickets(base, kind, items, 1);
      }
      throw error;
    });
  }

  /* CONTRACT 6.1. Resolves the gallery link, or rejects on any error, a malformed answer or after
     GALLERY_TIMEOUT_MS. Only the staff gallery page (CONTRACT 6.2 REVISED), on this shop's host or
     on finejewellerybycolette.com, is accepted into the email. */
  function requestGallery(base, tokens, controller) {
    var timer = window.setTimeout(function () { if (controller) controller.abort(); }, GALLERY_TIMEOUT_MS);
    return fetch(base + '/website-photo-gallery', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      signal: controller ? controller.signal : undefined,
      body: JSON.stringify({ tokens: tokens })
    }).then(function (response) {
      return response.json().then(function (data) {
        window.clearTimeout(timer);
        var url = data && data.galleryUrl;
        var match = typeof url === 'string' && /^https:\/\/([a-z0-9.-]+)\/pages\/photographs#g=[0-9a-f]{32}$/i.exec(url);
        var host = match && match[1].toLowerCase();
        if (response.ok && host && (host === window.location.host.toLowerCase() || host === 'finejewellerybycolette.com' || host === 'www.finejewellerybycolette.com')) return url;
        throw new Error('gallery');
      });
    }).catch(function (error) {
      window.clearTimeout(timer);
      throw error;
    });
  }

  /* Resolves on a 2xx; rejects on anything else, or after STALL_MS without upload progress. */
  function put(item, onProgress) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var stall = null;
      function arm() {
        if (stall) window.clearTimeout(stall);
        stall = window.setTimeout(function () {
          xhr.abort();
          reject(new Error('stalled'));
        }, STALL_MS);
      }
      function done() {
        if (stall) window.clearTimeout(stall);
        item.xhr = null;
      }
      item.xhr = xhr;
      xhr.open('PUT', item.signedUrl);
      xhr.setRequestHeader('Content-Type', item.type);
      xhr.setRequestHeader('x-upsert', 'false');
      xhr.upload.onprogress = function (event) {
        arm();
        if (event.lengthComputable && event.total > 0) onProgress(event.loaded / event.total);
      };
      xhr.onload = function () {
        done();
        if (xhr.status >= 200 && xhr.status < 300) resolve();
        else reject(new Error('status ' + xhr.status));
      };
      xhr.onerror = function () { done(); reject(new Error('network')); };
      xhr.onabort = function () { done(); reject(new Error('aborted')); };
      arm();
      xhr.send(item.blob);
    });
  }

  function init(root) {
    var form = root.closest('form');
    var base = (root.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
    if (!form || !base || form.fjbcPhotos) return;

    var kind = root.getAttribute('data-photo-kind') === 'appointment' ? 'appointment' : 'contact';
    var input = root.querySelector('[data-photo-input]');
    var pick = input.closest('.pu-pick');
    var pickText = pick.querySelector('.button-label');
    var pickWords = pickText.textContent;
    var list = root.querySelector('[data-photo-list]');
    var message = root.querySelector('[data-photo-message]');
    var live = root.querySelector('[data-photo-live]');
    var summary = root.querySelector('[data-photo-summary]');
    var items = [];
    var serial = 0;
    var refusal = '';
    var waiters = [];
    var queue = Promise.resolve();
    /* The gallery answer for one set of sent photographs: key is their view tokens in order,
       status 'asking', 'done' (url set) or 'failed'. A new set of photographs asks again. */
    var gallery = { key: '', status: '', url: '', controller: null };

    /* The field is live: the email sentence and the placeholder's email line give way to it. */
    root.hidden = false;
    var lineId = root.getAttribute('data-email-line');
    var line = lineId && document.getElementById(lineId);
    if (line && form.contains(line)) {
      line.hidden = true;
      form.querySelectorAll('[aria-describedby]').forEach(function (control) {
        var ids = control.getAttribute('aria-describedby').split(/\s+/).filter(function (id) { return id && id !== lineId; });
        if (ids.length) control.setAttribute('aria-describedby', ids.join(' '));
        else control.removeAttribute('aria-describedby');
      });
    }
    var placeholder = root.getAttribute('data-body-placeholder');
    var body = form.querySelector('textarea[name="contact[body]"]');
    if (placeholder && body) body.setAttribute('placeholder', placeholder);

    function uploading() {
      return items.some(function (item) { return item.status === 'preparing' || item.status === 'waiting' || item.status === 'uploading'; });
    }

    function sentTokens() {
      return items.filter(function (item) { return item.status === 'sent'; }).map(function (item) {
        var match = /[?&]t=([0-9a-f]{32})(?:&|$)/i.exec(item.viewUrl || '');
        return match ? match[1] : '';
      }).filter(Boolean);
    }

    /* True until this set of sent photographs has a gallery answer, link or failure. */
    function needsGallery() {
      var tokens = sentTokens();
      if (!tokens.length) return false;
      return gallery.key !== tokens.join(',') || gallery.status === 'asking';
    }

    function pending() {
      return uploading() || needsGallery();
    }

    function askGallery(callback) {
      var tokens = sentTokens();
      var key = tokens.join(',');
      if (!needsGallery()) return callback();
      if (gallery.key === key && gallery.status === 'asking') {
        gallery.callbacks.push(callback);
        return;
      }
      var earlier = gallery.status === 'asking' && gallery.callbacks ? gallery.callbacks : [];
      if (gallery.controller) gallery.controller.abort();
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var mine = { key: key, status: 'asking', url: '', controller: controller, callbacks: earlier.concat([callback]) };
      gallery = mine;
      function answer(status, url) {
        if (gallery !== mine || mine.status !== 'asking') return;
        mine.status = status;
        mine.url = url || '';
        mine.controller = null;
        var callbacks = mine.callbacks;
        mine.callbacks = [];
        callbacks.forEach(function (fn) { fn(); });
      }
      requestGallery(base, tokens, controller).then(function (url) { answer('done', url); }, function () { answer('failed'); });
      /* Without AbortController the fetch cannot be cancelled, so the timeout is kept here too. */
      if (!controller) window.setTimeout(function () { answer('failed'); }, GALLERY_TIMEOUT_MS);
    }

    /* "Send without photographs" while the gallery call runs: numbered links, no further wait. */
    function skipGallery() {
      var tokens = sentTokens();
      if (!tokens.length) return;
      var key = tokens.join(',');
      if (gallery.key === key && gallery.status === 'done') return;
      var callbacks = gallery.key === key && gallery.callbacks ? gallery.callbacks : [];
      if (gallery.controller) gallery.controller.abort();
      gallery = { key: key, status: 'failed', url: '', controller: null, callbacks: [] };
      callbacks.forEach(function (fn) { fn(); });
    }

    function announce(text) {
      live.textContent = '';
      window.setTimeout(function () { live.textContent = text; }, 60);
    }

    function stateText(item) {
      if (item.status === 'preparing') return 'Preparing';
      if (item.status === 'waiting') return 'Waiting to send';
      if (item.status === 'uploading') return item.progress > 0 ? 'Sending, ' + Math.round(item.progress * 100) + '%' : 'Sending';
      if (item.status === 'sent') return 'Sent';
      return item.error || 'Not sent. Please email it to us.';
    }

    function setMessage(parts) {
      message.textContent = '';
      parts.forEach(function (part, index) {
        if (index > 0) message.appendChild(document.createTextNode(' '));
        var withEmail = part.split(EMAIL);
        withEmail.forEach(function (chunk, i) {
          if (i > 0) {
            var link = document.createElement('a');
            link.href = 'mailto:' + EMAIL;
            link.textContent = EMAIL;
            message.appendChild(link);
          }
          if (chunk) message.appendChild(document.createTextNode(chunk));
        });
      });
    }

    function render() {
      list.hidden = items.length === 0;
      items.forEach(function (item, index) {
        var number = index + 1;
        item.el.setAttribute('data-state', item.status);
        item.name.textContent = 'Photograph ' + number;
        item.state.textContent = stateText(item);
        item.remove.setAttribute('aria-label', 'Remove photograph ' + number);
        item.bar.style.transform = 'scaleX(' + (item.status === 'uploading' ? item.progress : item.status === 'sent' ? 1 : 0) + ')';
      });

      var full = items.length >= MAX_FILES;
      input.disabled = full;
      pick.classList.toggle('is-full', full);
      pickText.textContent = full ? 'Five photographs added' : pickWords;

      var failed = items.filter(function (item) { return item.status === 'failed' && !item.skipped; });
      var parts = [];
      if (refusal) parts.push(refusal);
      if (failed.length && failed.length === items.length) {
        parts.push((failed.length === 1 ? 'Your photograph' : 'Your photographs') + ' could not be sent. Your request will still be sent. Please email ' + (failed.length === 1 ? 'it' : 'them') + ' to ' + EMAIL + ' with your name.');
      } else if (failed.length) {
        parts.push((failed.length === 1 ? 'One photograph' : spelled(failed.length) + ' photographs') + ' could not be sent. Your request will still be sent. Please email ' + (failed.length === 1 ? 'it' : 'them') + ' to ' + EMAIL + ' with your name.');
      }
      setMessage(parts);

      if (!uploading() && waiters.length) {
        var callbacks = waiters;
        waiters = [];
        callbacks.forEach(function (callback) { callback(); });
      }
    }

    function finish(item, status, error) {
      release(item);
      if (item.removed || item.skipped) return;
      item.status = status;
      if (error) item.error = error;
      render();
      var number = items.indexOf(item) + 1;
      if (status === 'sent') announce('Photograph ' + number + ' sent.');
      else if (!item.skipped) announce('Photograph ' + number + ' could not be sent.');
    }

    function addRow(item) {
      var li = document.createElement('li');
      li.className = 'pu-item';
      var thumb = document.createElement('span');
      thumb.className = 'pu-thumb';
      var meta = document.createElement('span');
      meta.className = 'pu-meta';
      var name = document.createElement('span');
      name.className = 'pu-name';
      var state = document.createElement('span');
      state.className = 'pu-state';
      meta.appendChild(name);
      meta.appendChild(state);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'pu-remove';
      remove.textContent = 'Remove';
      var bar = document.createElement('span');
      bar.className = 'pu-bar';
      bar.setAttribute('aria-hidden', 'true');
      var fill = document.createElement('span');
      bar.appendChild(fill);
      li.appendChild(thumb);
      li.appendChild(meta);
      li.appendChild(remove);
      li.appendChild(bar);
      list.appendChild(li);
      item.el = li;
      item.thumbBox = thumb;
      item.name = name;
      item.state = state;
      item.remove = remove;
      item.bar = fill;
      remove.addEventListener('click', function () { removeItem(item); });
    }

    function showThumb(item, blob) {
      try {
        item.thumbUrl = URL.createObjectURL(blob);
      } catch (error) {
        return;
      }
      /* The object URL lives only until the image loads or fails: the loaded image is copied into
         a small canvas, so neither the URL nor the full photograph stays held for the preview. */
      var img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      function revoke() {
        if (item.thumbUrl) URL.revokeObjectURL(item.thumbUrl);
        item.thumbUrl = null;
      }
      img.onload = function () {
        revoke();
        if (item.removed) return;
        var side = Math.min(img.naturalWidth, img.naturalHeight);
        if (!side) return;
        var canvas = document.createElement('canvas');
        canvas.width = THUMB_PX;
        canvas.height = THUMB_PX;
        canvas.setAttribute('aria-hidden', 'true');
        canvas.style.cssText = 'position:absolute;inset:0;display:block;width:100%;height:100%';
        try {
          canvas.getContext('2d').drawImage(img, (img.naturalWidth - side) / 2, (img.naturalHeight - side) / 2, side, side, 0, 0, THUMB_PX, THUMB_PX);
        } catch (error) {
          return;
        }
        img.replaceWith(canvas);
        img.removeAttribute('src');
      };
      img.onerror = function () {
        revoke();
        img.remove();
      };
      img.src = item.thumbUrl;
      item.thumbBox.appendChild(img);
    }

    /* After success or a final failure only the row, the reference and the view link are kept. */
    function release(item) {
      item.blob = null;
      item.signedUrl = null;
      item.file = null;
    }

    function removeItem(item) {
      var index = items.indexOf(item);
      if (index < 0) return;
      item.removed = true;
      if (item.xhr) item.xhr.abort();
      if (item.thumbUrl) URL.revokeObjectURL(item.thumbUrl);
      item.thumbUrl = null;
      release(item);
      item.el.remove();
      items.splice(index, 1);
      refusal = '';
      render();
      announce('Photograph ' + (index + 1) + ' removed.');
      var next = items[index] || items[index - 1];
      if (next) next.remove.focus();
      else input.focus();
    }

    /* Groups under the contract's 25 MB per request, in choice order. */
    function groups(batch) {
      var out = [];
      var current = [];
      var total = 0;
      batch.forEach(function (item) {
        if (current.length && total + item.blob.size > MAX_TOTAL) {
          out.push(current);
          current = [];
          total = 0;
        }
        current.push(item);
        total += item.blob.size;
      });
      if (current.length) out.push(current);
      return out;
    }

    /* CONTRACT section 1: each 400 code has its own line; 429, 503 and the rest read as not sent. */
    function ticketError(error) {
      if (error.status === 400 && error.code === 'too_large') return 'Too large to send. Please email it to us.';
      if (error.status === 400 && error.code === 'bad_type') return 'Only JPEG, PNG, WebP or HEIC photographs can be sent. Please email it to us.';
      if (error.status === 400 && error.code === 'too_many_files') return 'No more than five photographs can be sent. Please email it to us.';
      if (error.status === 400 && error.code === 'bad_request') return 'The upload service could not accept this photograph. Please email it to us.';
      return 'Not sent. Please email it to us.';
    }

    function sendGroup(group) {
      var batchItems = group.filter(function (item) { return !item.removed && item.status === 'waiting'; });
      if (!batchItems.length) return Promise.resolve();
      return requestTickets(base, kind, batchItems).then(function (data) {
        batchItems.forEach(function (item, index) {
          var upload = data.uploads.filter(function (entry) { return entry.index === index; })[0] || data.uploads[index];
          if (!upload || !upload.signedUrl || !upload.viewUrl) {
            item.status = 'failed';
            release(item);
            return;
          }
          item.signedUrl = upload.signedUrl;
          item.viewUrl = upload.viewUrl;
          item.reference = data.reference;
        });
        render();
        return batchItems.reduce(function (chain, item) {
          return chain.then(function () {
            if (item.removed || item.status !== 'waiting') return null;
            item.status = 'uploading';
            item.progress = 0;
            render();
            var progress = function (fraction) {
              if (item.removed) return;
              item.progress = fraction;
              render();
            };
            return put(item, progress).catch(function () {
              if (item.removed || item.skipped) throw new Error('stopped');
              item.progress = 0;
              render();
              return put(item, progress);
            }).then(function () {
              finish(item, 'sent');
            }, function () {
              if (!item.skipped) finish(item, 'failed');
            });
          });
        }, Promise.resolve());
      }, function (error) {
        batchItems.forEach(function (item) {
          release(item);
          if (!item.removed && !item.skipped) {
            item.status = 'failed';
            item.error = ticketError(error);
          }
        });
        render();
        announce(batchItems.length === 1 ? 'The photograph could not be sent.' : 'The photographs could not be sent.');
      });
    }

    function addFiles(files) {
      var room = MAX_FILES - items.length;
      var accepted = files.slice(0, Math.max(0, room));
      var refused = files.length - accepted.length;
      refusal = refused > 0
        ? 'You can send up to five photographs. ' + (refused === 1 ? 'One photograph was' : spelled(refused) + ' photographs were') + ' not added.'
        : '';
      var batch = accepted.map(function (file) {
        serial += 1;
        var item = { id: serial, file: file, status: 'preparing', progress: 0 };
        items.push(item);
        addRow(item);
        return item;
      });
      render();
      if (refused > 0) announce(refusal);
      if (!batch.length) return;
      announce('Sending ' + batch.length + ' ' + photographs(batch.length) + '.');

      /* One photograph decodes at a time: a 48 MP phone photograph is large in memory. */
      var prepared = batch.reduce(function (chain, item) {
        return chain.then(function () {
          if (item.removed || item.skipped) return null;
          return prepareWithin(item.file).then(function (result) {
            if (item.removed || item.skipped) return;
            item.blob = result.blob;
            item.type = result.type;
            item.file = null;
            if (result.thumb) showThumb(item, result.blob);
            item.status = 'waiting';
            render();
          }, function (error) {
            finish(item, 'failed', error.message);
          });
        });
      }, Promise.resolve());

      queue = queue.then(function () { return prepared; }).then(function () {
        var ready = batch.filter(function (item) { return !item.removed && item.status === 'waiting'; });
        return groups(ready).reduce(function (chain, group) {
          return chain.then(function () { return sendGroup(group); });
        }, Promise.resolve());
      }).catch(function () {
        /* A fault here leaves the rows failed; the form still sends. */
        items.forEach(function (item) {
          if (item.status !== 'sent' && item.status !== 'failed') item.status = 'failed';
          if (item.status === 'failed') release(item);
        });
        render();
      });
    }

    input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || []);
      input.value = '';
      if (files.length) addFiles(files);
    });

    /* CONTRACT sections 4 and 6.3, on one line because the store's email joins lines. No
       photographs chosen: the field is absent, not empty. */
    function write() {
      if (!items.length) {
        summary.value = '';
        summary.disabled = true;
        return;
      }
      var sent = items.filter(function (item) { return item.status === 'sent'; });
      var references = [];
      sent.forEach(function (item) {
        if (item.reference && references.indexOf(item.reference) < 0) references.push(item.reference);
      });
      var linked = gallery.status === 'done' && gallery.key === sentTokens().join(',') ? gallery.url : '';
      var links = linked
        ? 'See ' + (sent.length === 1 ? 'it' : 'them') + ': ' + linked
        : sent.map(function (item, index) { return 'Photo ' + (index + 1) + ': ' + item.viewUrl; }).join(' ');
      var text;
      if (sent.length && sent.length === items.length) {
        text = linked
          ? sent.length + ' ' + photographs(sent.length) + ', reference ' + references.join(', ') + '. ' + links
          : sent.length + ' ' + photographs(sent.length) + ' attached. Reference ' + references.join(', ') + '. ' + links;
      } else if (sent.length) {
        text = 'Photographs: upload did not finish (' + sent.length + ' of ' + items.length + ' sent). Reference ' + references.join(', ') + '. '
          + links + ' The customer was asked to email the rest to ' + EMAIL + '.';
      } else {
        text = 'Photographs: the customer chose photographs but they could not be sent. They were asked to email them to ' + EMAIL + '.';
      }
      summary.value = text;
      summary.disabled = false;
    }

    /* "Send without photographs": stop what is still on its way; what was sent stays sent. */
    function abandon() {
      items.forEach(function (item) {
        if (item.status === 'preparing' || item.status === 'waiting' || item.status === 'uploading') {
          item.skipped = true;
          item.status = 'failed';
          item.error = 'Not sent. Please email it to us.';
          if (item.xhr) item.xhr.abort();
          release(item);
        }
      });
      skipGallery();
      render();
      write();
    }

    /* Calls back once nothing is on its way and the gallery call, if one is needed, has answered. */
    function settled(callback) {
      var after = function () { askGallery(callback); };
      if (!uploading()) after();
      else waiters.push(after);
    }

    /* How many photographs still hold bytes or an upload address (only those still on their way). */
    function held() {
      return items.filter(function (item) { return item.blob || item.signedUrl || item.file; }).length;
    }

    form.fjbcPhotos = { pending: pending, uploading: uploading, settled: settled, abandon: abandon, write: write, held: held };
    render();
  }

  function start() {
    document.querySelectorAll('[data-photo-upload]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
